import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";

import PhishingRoutes from "./routes/PhishingRoutes";

const BACKEND_URL = "https://dv2.culsight.com";
const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const API = `${BACKEND_URL}/api`;
export const FAST_API = `${BACKEND_URL}/fastapi`;

// API Helper with auth
export const apiClient = axios.create({
  baseURL: API,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// FastAPI client with auth
export const fastApiClient = axios.create({
  baseURL: FAST_API,
});

fastApiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

fastApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("token"));

  const fetchUser = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await apiClient.get("/auth/me");
      setUser(res.data);
      setIsAuthenticated(true);
    } catch (err) {
      localStorage.removeItem("token");
      setIsAuthenticated(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        loading,
        isAuthenticated,
        setIsAuthenticated,
        logout,
        refreshUser: fetchUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          richColors
          toastOptions={{
            style: { fontFamily: "Inter, sans-serif" },
          }}
        />
        <PhishingRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;